import SimpleBar from 'simplebar';
import FormElements from './brand-venues/FormElements';
import ViewModeToggle from './brand-venues/ViewModeToggle';
import FilterPopup from './brand-venues/Popups/FilterPopup';
import CardPopup from './brand-venues/Popups/CardPopup';
import Filter from './brand-venues/Filter';
import BookingGatherTab from './brand-venues/BookingGatherTab';

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    // Initialize all brand-venues components on the page
    const brandVenuesBlock = document.querySelector('.brand-venues');

    if (brandVenuesBlock) {
      // eslint-disable-next-line no-new
      new FormElements(brandVenuesBlock);

      // eslint-disable-next-line no-new
      new FilterPopup(brandVenuesBlock);

      // eslint-disable-next-line no-new
      new CardPopup(brandVenuesBlock);

      // eslint-disable-next-line no-new
      new ViewModeToggle(brandVenuesBlock);

      // eslint-disable-next-line no-new
      new Filter(brandVenuesBlock);

      // eslint-disable-next-line no-new
      new BookingGatherTab();

      const simpleBarElements = brandVenuesBlock.querySelectorAll('[data-simplebar]');
      simpleBarElements.forEach((element) => {
        // eslint-disable-next-line no-new
        new SimpleBar(element);
      });
    }
  }, 0);
});
